import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-page-withus',
  templateUrl: './page-withus.component.html',
  styleUrls: ['./page-withus.component.css']
})

/**
 * Aboutus Two Component
 */
export class PageWithUsComponent implements OnInit {
  navClass = 'nav-light';
  
      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = false;
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  num: number = 0;
  option = {
    startVal: this.num,
    useEasing: true,
    duration: 1,
    decimalPlaces: 0,
  };

  /**
  * Open modal for show the video
  * @param content content of modal
  */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

}
